/**
 * Represents component with list of time values
 */

import React from 'react';
import { format, addMinutes, startOfDay } from 'date-fns';
import { range } from 'lodash';
import { Select } from 'semantic-ui-react';

function TimeSelect({
    meta: _meta,
    startAt: startAtProp,
    endAt,
    step,
    formatTime,
    ...props
}) {
    let startAt = startAtProp;
    if (step === 60 && (startAt / 30) % 2 > 0) {
        startAt = startAt - 30;
    }
    const options = range(startAt, endAt + step, step).map(time => {
        const text = format(
            addMinutes(startOfDay(new Date()), time),
            formatTime,
        );
        return { value: time, text };
    });

    return <Select options={options} {...props} />;
}

export default TimeSelect;
